import { TThunkAction } from '../../types/redux';

export const persisFilters = (): TThunkAction => {
  return (_, getState, context) => {
    const { logger, config } = context;
    const localstorageKey = config.get<string>('mainpage.persistFiltersKey') || '__mainpage__last_filters_state__';

    try {
      const {
        filters: { jsonQuery },
      } = getState();

      window.localStorage.setItem(localstorageKey, JSON.stringify(jsonQuery));
    } catch (error) {
      logger.warning('Unable to persist filters state to localStorage', error);
    }
  };
};
